import layout from './EmbeddedMediumLink.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedMediumLinkViewModel from '@/ViewModels/Controls/EmbeddedMediumLinkViewModel';

export default class EmbeddedMediumLink extends Control {
    private jQueryControl: JQuery;

    public constructor(private viewModel: EmbeddedMediumLinkViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated((widget) => {
            this.applyBindings(this.jQueryControl, {
                controlName: 'embeddedmediumlink',
                tooltip: this.context.tooltip
            });
        });
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<span></span>');
        this.applyTemplate(layout, this.jQueryControl);
        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('EmbeddedMediumLink', EmbeddedMediumLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');